module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.css
// module id = ./src/app/main/main.component.css
// module chunks = main